import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { RequestsTab } from './PrayerScreen';

export default function PrayerRequestsScreen() {
  const {
    currentUserId, wallItems, wallLoading,
    handleWallSaved, handleWallDelete,
    handleWallUpdateAdded, handleWallUpdateDeleted,
    wallEditItem, setWallEditItem, wallAnswerItem, setWallAnswerItem,
  } = useOutletContext();

  return (
    <RequestsTab
      currentUserId={currentUserId}
      wallItems={wallItems}
      wallLoading={wallLoading}
      onSaved={handleWallSaved}
      onDelete={handleWallDelete}
      onMarkAnswered={setWallAnswerItem}
      onUpdateAdded={handleWallUpdateAdded}
      onUpdateDeleted={handleWallUpdateDeleted}
      editItem={wallEditItem}
      setEditItem={setWallEditItem}
      answerItem={wallAnswerItem}
      setAnswerItem={setWallAnswerItem}
    />
  );
}
